import { NgModule } from '@angular/core';
import { provideConfig } from '@spartacus/core';
import { LayoutConfig } from '@spartacus/storefront';
import { CustomAsmMainUiComponent } from './components';

@NgModule({
  imports: [CustomAsmMainUiComponent],
  providers: [
    provideConfig(<LayoutConfig>{
      launch: {
        ASM: {
          outlet: 'asm-outlet',
          component: CustomAsmMainUiComponent,
        },
      },
    }),
  ],
})
export class AsmUiModule {}
